module.exports = __webpack_public_path__ + "img/front1.0fde97e0.png";